module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.014b0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/title-banner1-type4.png
// module id = yPK5
// module chunks = 1